import React, { useState } from 'react';
import { 
  Box, 
  Tabs, 
  Tab, 
  Typography 
} from '@mui/material';
import MonitoringDashboard from './dashboard/MonitoringDashboard';
import TaskMonitor from './tasks/TaskMonitor';

const MonitoringTab = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
          aria-label="monitoring tabs"
        >
          <Tab label="Dashboard" id="tab-0" aria-controls="tabpanel-0" />
          <Tab label="Tasks" id="tab-1" aria-controls="tabpanel-1" />
          <Tab label="Job Executions" id="tab-2" aria-controls="tabpanel-2" disabled />
          <Tab label="Job Performance" id="tab-3" aria-controls="tabpanel-3" disabled />
        </Tabs>
      </Box>

      <TabPanel value={activeTab} index={0}>
        <MonitoringDashboard />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <TaskMonitor />
      </TabPanel>
      <TabPanel value={activeTab} index={2}>
        <Box sx={{ p: 3 }}>
          <Typography variant="subtitle1" color="text.secondary" sx={{ fontStyle: 'italic' }}>
            Coming soon in future releases
          </Typography>
        </Box>
      </TabPanel>
      <TabPanel value={activeTab} index={3}>
        <Box sx={{ p: 3 }}>
          <Typography variant="subtitle1" color="text.secondary" sx={{ fontStyle: 'italic' }}>
            Coming soon in future releases
          </Typography>
        </Box>
      </TabPanel>
    </Box>
  );
};

// Custom TabPanel component
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>{children}</Box>
      )}
    </div>
  );
}

export default MonitoringTab;